<template>
  <section ref="section" class="photogrphy__wideAngle">
    <div
      ref="text"
      class="photography__txt text-intro wow textInPartMotion"
      :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
      data-wow-delay="0.3s"
      data-wow-offset="100"
      :class="progress > 0.4 ? 'photography__txt-in-background' : ''"
    >
      <div
        class="photography__txt-title wow textInPartMotion"
        :data-wow-duration="vm.isMobile ? '1.2s' : '.4s'"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <p class="title">超广角镜头</p>
        <p class="sub-title">画面多大，都能装下</p>
      </div>
      <div class="photography__txt-content description">
        119度超广角，把你爱的世界一镜装下。除此之外，暗光场景下的亮度和降噪效果也实力不俗，想拍就拍，不必将就。
        <sup>2</sup>
      </div>
    </div>
    <div v-if="vm.isMobile" class="wideAngle-container">
      <img
        v-lazy="require('../../assets/photography/photography-wideAngle-larger-mobile.jpg')"
        :data-webp="require('../../assets/photography/photography-wideAngle-larger-mobile.webp')"
        alt="ColrorOS 11"
        :style="`opacity: ${largerMobileOpacity}`"
        class="wideAngle-img-larger"
      />
      <img
        v-lazy="require('../../assets/photography/photography-wideAngle-mobile.jpg')"
        :data-webp="require('../../assets/photography/photography-wideAngle-mobile.webp')"
        alt="ColrorOS 11"
        class="wideAngle-img-small"
        :style="`opacity: ${smallMobileOpacity}`"
      />
    </div>
    <img
      v-if="!vm.isMobile"
      v-lazy="require('../../assets/photography/photography-wideAngle-larger.jpg')"
      alt="ColrorOS 11"
      class="wideAngle-img"
    />
    <canvas v-if="!vm.isMobile" id="cvs" ref="canvas" width="100%" height="100%" class="wideAngle-container"></canvas>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  inject: ['lang', 'vm'],
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      phoneScaleRate: 0,
      progress: 0,
      show: false,

      largerMobileOpacity: 0.12,
      smallMobileOpacity: 1
    };
  },
  watch: {
    progress() {
      this.scrollDrawRect();
    }
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler() {
      if (this.vm.isMobile) {
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
        if (!this.mobileScene) {
          this.initMobileScroll();
        } else {
          this.mobileScene.offset(this.mobileScene.offset() + window.innerHeight - this.preInnerHeight);
          this.preInnerHeight = window.innerHeight;
          this.ignoreMobileResizeFirstChange = true;
          // this.$nextTick(() => {
          //   this.updateMobileProgress(this.mobileScene.progress());
          //   console.log('change change', this.preProgress, progress, this.mobileScene.progress());
          // });
        }
      } else {
        if (this.mobileScene) {
          this.mobileScene.destroy(true);
          this.mobileScene = null;
        }
        if (!this.scene) this.initScroll();
        this.scrollDrawRect();
      }
    },
    mobileSceneOffset() {
      const anitSakeImgHeight = document.querySelector('.photography__antiShake__videos-warp').clientHeight
        ? 0
        : (182 / 320) * (window.innerWidth - 40);
      const wideAngleImg = document.querySelector('.wideAngle-container').clientHeight
        ? 0
        : (240 / 335) * (window.innerWidth - 40);
      return (
        document.querySelector('#photography').clientHeight +
        document.querySelector('.photography__antiShake').clientHeight +
        anitSakeImgHeight -
        // wideangle固定的时候，顶部距离的高度差
        (window.innerHeight - this.$refs.section.clientHeight - wideAngleImg) -
        2
      );
    },
    initMobileScroll() {
      // const offset = window.innerHeight - this.$refs.section.clientHeight - (240 / 335) * (window.innerWidth - 40);
      // const offset = this.mobileSceneOffset();
      this.preInnerHeight = window.innerHeight;
      this.mobileScene = new ScrollMagic.Scene({
        duration: 0.4 * window.innerHeight,
        // triggerElement: '.photography',
        triggerElement: '.wideAngle-container',
        // triggerHook: 0,
        // offset
        triggerHook: 1,
        offset: 0.25 * window.innerHeight + 50
      })
        // .setPin('.photography')
        .addTo(Controller)
        .on('progress', e => {
          if (this.ignoreMobileResizeFirstChange) {
            // 避免rezisehe 和 scroll 的来回跳变，resize之后，先scroll触发progress，再是resize的offset触发的progress，如果需要可以再offset设置加个nextTick
            this.ignoreMobileResizeFirstChange = false;
            return;
          }
          this.largerMobileOpacity = 0.12 + 0.78 * e.progress;
          this.smallMobileOpacity = 1 - e.progress;
        });
    },
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        duration: window.innerHeight,
        triggerElement: '.photogrphy__wideAngle',
        triggerHook: 0
      })
        .setPin('.photogrphy__wideAngle')
        .addTo(Controller)
        .on('progress', e => {
          this.updateBezier('progress', e.progress, 200);
        });
      setTimeout(() => {
        this.scrollDrawRect();
      });
    },
    scrollDrawRect() {
      let x, y, width, height;
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;
      const progress = Math.min(1, this.progress / 0.75);

      if (innerWidth > 1220) {
        width = 1050 + (innerWidth - 1050) * progress;
      } else {
        width = innerWidth * 0.86 + innerWidth * 0.14 * progress;
      }

      x = (innerWidth - width) / 2;
      y = (this.$refs.text.clientHeight + 88) * (1 - progress);
      height = innerHeight - y - 105 * (1 - progress);
      this.drawRect(x, y, width, height);
    },
    drawRect(x, y, width, height, radius = 24) {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.globalCompositeOperation = 'source-over';
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.globalCompositeOperation = 'xor';
      context.fillStyle = '#fff';
      // this.drawRoundedRect(context, 200, 200, 500, 500, 10);
      this.drawRoundedRect(context, x, y, width, height, radius * (1 - this.progress));
      // console.log(context, canvas.width, canvas.height);
      window.context = context;
    },
    // 绘制圆角矩形
    drawRoundedRect(ctx, x, y, width, height, radius) {
      ctx.moveTo(x, y + radius);
      ctx.beginPath();
      ctx.arc(x + radius, y + radius, radius, Math.PI, 1.5 * Math.PI);
      ctx.arc(x + width - radius, y + radius, radius, 1.5 * Math.PI, 2 * Math.PI);
      ctx.arc(x + width - radius, y + height - radius, radius, 0, 0.5 * Math.PI);
      ctx.arc(x + radius, y + height - radius, radius, 0.5 * Math.PI, Math.PI);
      ctx.closePath();
      ctx.fill();
    }
  }
};
</script>
<style lang="scss">
@media screen and (min-width: 734px) {
  .photogrphy__wideAngle {
    position: relative;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0;
    /* padding-bottom: 105px; */
    height: 100vh;

    .photography__txt {
      position: relative;
      z-index: 2;
      display: inline-flex;
      padding-top: 16.25vh;
      text-align: left;
    }
    .wideAngle-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .wideAngle-container {
      position: absolute;
      left: 0;
      top: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }
    .photography__txt-in-background {
      .title,
      .photography__txt-content {
        color: rgba(255, 255, 255, 0.7);
      }
      .sub-title {
        color: #fff;
      }
    }
  }
}
@media screen and (min-width: 734px) and (max-height: 760px) {
  .photogrphy__wideAngle .photography__txt {
    padding-top: 80px;
  }
}
.photogrphy__wideAngle {
  padding-bottom: 60px;
}
.wideAngle-container {
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  font-size: 0;
  .wideAngle-img-larger {
    width: 100%;
  }
  .wideAngle-img-small {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 65.37%;
  }
}
</style>
